<template>
    <div>
        <div class="mini-card">
            <el-card>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <h2>{{ operatorFullName }}</h2>
                        <div class="info-identity">
                            <p><span>{{ $t('associated_node_id') }}: </span><span class="data-display">{{ operator.beaconId }}</span></p>
                        </div>
                        <el-row>
                            <el-tooltip class="item" effect="dark" :content="$t('edit')" placement="top">
                                <el-button v-if="isSuperAdmin" type="primary" icon="el-icon-edit" @click="editoperator" circle></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="$t('duplicate')" placement="top">
                                <el-button v-if="isSuperAdmin" type="primary" icon="el-icon-document-copy" @click="duplicateoperator" circle></el-button>
                            </el-tooltip>
                            <!-- <el-tooltip class="item" effect="dark" :content="$t('details')" placement="top">
                                <el-button v-if="isSuperAdmin" type="primary" icon="el-icon-s-data" @click="getDetailsView" circle></el-button>
                            </el-tooltip> -->
                        </el-row>
                    </el-col>
                    <!-- <el-col :span="9">
                        <div class="table-card">
                            <h3>{{ $t('last_controlled_production_area') }}</h3>
                            <el-table
                            :data="tableData"
                            size="small">
                            <el-table-column
                                prop="ref"
                                label="Ref">
                            </el-table-column>
                            <el-table-column
                                prop="totalTime"
                                label="Tps tot.">
                            </el-table-column>
                            <el-table-column
                                prop="lastCheck"
                                label="Date ctrl.">
                            </el-table-column>
                            </el-table>
                        </div>
                    </el-col> -->
                </el-row>
            </el-card>
        </div>
        <!-- start Modal for Create OF form -->
        <el-dialog
            width="1200px"
            :visible.sync="dialogFormVisible"
            :modalAppendToBody="false">
            <CreateOperator :formStateModal="ofFormType" :ofSelected="operator" :key="dialogFormVisible" @closeForm="closeForm"></CreateOperator>
        </el-dialog>
        <!-- end Modal for Create OF form -->
    </div>
</template>

<script>
import CreateOperator from '../components/operator/CreateOperator.vue'
import DateTimeManipulation from '../mixins/DateTimeManipulation'

export default {
    components: {
        CreateOperator
    },
    props: {
        operator: {
            type: Object,
        }
    },
    data() {
        return {
            operation: {
                name: 'OFXXXXX01',
                totalTime: 127,
                status: 'En cours',
                cadenceGap: '-2 sec / p',
                TotalEstimedCost: 5648.21,
                start: '01/01/1970',
                end: '08/01/1970'
            },
            tableData: [{
                ref: 'ZXXXXXX3',
                totalTime: '5h56',
                lastCheck: '12/05/19'
            }, {
                ref: 'ZXXXXXX7',
                totalTime: '5h06',
                lastCheck: '14/04/19'
            }, {
                ref: 'ZXXXXXX9',
                totalTime: '23h12',
                lastCheck: '13/04/19'
            }, {
                ref: 'ZXXXXXX12',
                totalTime: '7h00',
                lastCheck: '13/04/19'
            }],
            ofFormType: 'edit',
            dialogFormVisible: false,
            isSuperAdmin: false,
        }
    },
    created() {
         this.isSuperAdmin = this.$store.getters.isSuperAdmin;
    },
    computed: {
        operatorFullName: function() {
            return `${this.operator.firstname} ${this.operator.lastname}`
        }
    },
    methods: {
        editoperator: function() {
            this.ofFormType = 'edit';
            this.dialogFormVisible = true;
        },
        duplicateoperator: function() {
            this.ofFormType = 'duplicate';
            this.dialogFormVisible = true;
        },
        getDetailsView: function() {
            this.$router.push({ name: 'operator-details', params: { id: this.operator.id } })
        },
        closeForm: function() {
            this.dialogFormVisible = false;
            this.$emit('closeForm', false);
        },
    },
    mixins: [DateTimeManipulation]
}
</script>

<style scoped>
    h3 {
        color: white;
    }

    .mini-card {
        margin-bottom: 20px;
    }

    .table-card {
        background-color: var(--color1light);
        padding: 10px;
        border-radius: 12px;
    }

    .info-identity {
        margin-bottom: 24px;

    }

    .info-identity > p {
        margin: 5px;
    }

    .data-display {
        font-weight: bold;
    }
</style>